export default {"src":"/_next/static/media/ConnexLogo.a8366b2e.svg","height":480,"width":640,"blurWidth":0,"blurHeight":0};